import { defineMessages, useIntl } from '@alltrails/shared/react-intl';
import useFiltersContext from 'hooks/useFiltersContext';
import iconFilterSrc from 'images/icons/search/icon-filter.svg';
import iconFilterActiveSrc from 'images/icons/search/icon-filter-active.svg';
import * as styles from './styles/styles.module.scss';

const { modalToggleIcon } = defineMessages({
  modalToggleIcon: {
    defaultMessage: 'view all search filters'
  }
});

type Props = {
  onClick: () => void;
};

export default function MobileFiltersModalButton({ onClick }: Props) {
  const intl = useIntl();

  const { hasAppliedFilters } = useFiltersContext();

  return (
    <span>
      <button type="button" className={styles.filtersModalButton} onClick={onClick}>
        <img alt={intl.formatMessage(modalToggleIcon)} src={hasAppliedFilters ? iconFilterActiveSrc : iconFilterSrc} />
      </button>
    </span>
  );
}
